import React, { PropTypes } from 'react';
import {Link} from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import HeaderNav from './HeaderNav'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/auth';

export class App extends React.Component {
  componentDidMount() {
    this.props.actions.syncSession();
  }

  render() {
    return (
      <div>
        <MuiThemeProvider muiTheme={getMuiTheme()}>
          <HeaderNav />
        </MuiThemeProvider>
        <MuiThemeProvider muiTheme={getMuiTheme()}>
          <div className="container">
            {this.props.children}
            {this.props.location.pathname !== '/' &&
              <Link to="/">Back to Home</Link>
            }
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired,
  children: PropTypes.element,
  location: PropTypes.object
};

/*
function mapStateToProps(state) {
  return {};
}
*/
function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/